import { ltmApiURL } from 'Constants/Constants';
import axios from 'axios';

const SpotltmClient = axios.create({
  baseURL: ltmApiURL,
  headers: {
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key':
      process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION,
  },
});

export default SpotltmClient;
